module.exports = __webpack_public_path__ + "static/img/group11.6dbeb99.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cronus/group11.png
// module id = B4QO
// module chunks = 0